import classNames from 'classnames';

import { CardContentNew } from 'modules/cards/components/Cards/CardContentNew';

import styles from './CardContentNew.module.css';

type Props = {
  title?: string;
  numbers: string;
  brand: 'visa' | 'mastercard';
  amount?: string;
  expiryDate: string;
  amountTooltip: string;
};

export const PhysicalCard = ({
  title,
  numbers,
  brand,
  amount,
  expiryDate,
  amountTooltip,
}: Props) => {
  return (
    <PhysicalCardBackground brand={brand}>
      <CardContentNew
        title={title}
        numbers={numbers}
        amount={amount}
        expiryDate={expiryDate}
        amountTooltip={amountTooltip}
        theme="light"
      />
    </PhysicalCardBackground>
  );
};

const PhysicalCardBackground = ({
  children,
  brand,
  className,
}: {
  children: React.ReactNode;
  brand: 'visa' | 'mastercard';
  className?: string;
}) => (
  <svg
    width="320"
    height="202"
    viewBox="0 0 320 202"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('relative h-[202px] w-[320px]', className)}
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H308C314.627 0 320 5.37258 320 12V190C320 196.627 314.627 202 308 202H12C5.37259 202 0 196.627 0 190V12Z"
      fill="url(#paint0_linear_1304_16647)"
    />
    <foreignObject x="0" y="0" width="100%" height="100%">
      {brand === 'visa' ? (
        <svg
          className={styles.brand}
          width="73"
          height="24"
          viewBox="0 0 73 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.1516 0.415685L31.2603 23.5702H25.4263L30.3176 0.415685H36.1516ZM60.9495 15.3671L64.0509 6.67886L65.8407 15.3671H60.9495ZM67.5349 23.5702H73L68.2317 0.415685H63.1901C62.6522 0.417277 62.1267 0.579853 61.6795 0.883044C61.2323 1.18624 60.8833 1.61653 60.6762 2.12003L51.8091 23.5702H58.012L59.2416 20.1199H66.8244L67.5349 23.5702ZM52.1233 16.0184C52.1233 9.90755 43.7891 9.56113 43.8437 6.83135C43.8437 5.99995 44.6362 5.12694 46.344 4.89138C48.3453 4.70208 50.3601 5.06098 52.178 5.93063L53.2027 1.02538C51.4551 0.358645 49.6047 0.0114851 47.7376 0C41.9036 0 37.7911 3.14542 37.7638 7.64885C37.7638 10.9883 40.6876 12.8451 42.9283 13.9536C45.169 15.0622 46.0024 15.8105 45.9888 16.8359C45.9888 18.3878 44.158 19.0668 42.4638 19.0945C40.358 19.1674 38.2692 18.6902 36.3975 17.7088L35.3182 22.7804C37.4149 23.5977 39.6437 24.0113 41.8899 23.9998C48.0928 23.9998 52.1507 20.8959 52.178 16.0876L52.1233 16.0184ZM27.708 0.484951L18.1441 23.6396H11.9003L7.18659 5.15466C7.14708 4.72572 7.00105 4.31396 6.76213 3.95776C6.52321 3.60156 6.19919 3.31257 5.82032 3.11776C3.96794 2.22019 2.0129 1.5592 0 1.15005L0.136636 0.471081H10.1924C10.8534 0.464001 11.4946 0.700234 11.997 1.13592C12.4994 1.57161 12.8291 2.17725 12.925 2.84061L15.4116 16.24L21.5598 0.471081L27.708 0.484951Z"
            fill="white"
          />
        </svg>
      ) : null}
      {brand === 'mastercard' ? (
        <svg
          className={styles.brand}
          width="320"
          height="202"
          viewBox="0 0 320 202"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g>
            <path
              d="M270.711 154.461H290.792V187.258H270.711V154.461Z"
              fill="#EA560D"
            />
            <path
              d="M272.778 170.868C272.776 167.71 273.492 164.593 274.872 161.752C276.252 158.912 278.26 156.422 280.745 154.472C277.668 152.054 273.973 150.551 270.081 150.133C266.19 149.716 262.26 150.401 258.741 152.112C255.221 153.822 252.253 156.489 250.177 159.806C248.101 163.123 247 166.958 247 170.871C247 174.785 248.101 178.619 250.177 181.936C252.253 185.254 255.221 187.92 258.741 189.63C262.26 191.341 266.19 192.026 270.081 191.609C273.973 191.192 277.668 189.688 280.745 187.27C278.26 185.319 276.251 182.829 274.871 179.987C273.491 177.146 272.775 174.027 272.778 170.868Z"
              fill="#E30613"
            />
            <path
              d="M312.497 183.788V183.116H312.787V182.977H312.097V183.116H312.369V183.788H312.497ZM313.835 183.788V182.977H313.627L313.383 183.556L313.14 182.977H312.931V183.788H313.082V183.174L313.308 183.701H313.464L313.69 183.174V183.788H313.835ZM314.49 170.862C314.49 174.776 313.389 178.611 311.312 181.928C309.235 185.245 306.267 187.912 302.747 189.622C299.227 191.332 295.297 192.017 291.405 191.599C287.514 191.181 283.819 189.677 280.742 187.258C283.225 185.307 285.233 182.816 286.614 179.976C287.994 177.135 288.711 174.018 288.711 170.859C288.711 167.701 287.994 164.584 286.614 161.743C285.233 158.902 283.225 156.412 280.742 154.461C283.819 152.042 287.514 150.537 291.405 150.119C295.297 149.701 299.227 150.387 302.747 152.097C306.267 153.807 309.235 156.473 311.312 159.791C313.389 163.108 314.49 166.943 314.49 170.856V170.862Z"
              fill="#F59E00"
            />
          </g>
        </svg>
      ) : null}
      {children}
    </foreignObject>
    <defs>
      <linearGradient
        id="paint0_linear_1304_16647"
        x1="-29.2174"
        y1="-16.6745"
        x2="353.214"
        y2="21.8904"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9276F0" />
        <stop offset="1" stopColor="#4F03BA" />
      </linearGradient>
    </defs>
  </svg>
);
